<template>
  <a-modal v-model="visible" :title="title" :destroyOnClose="true" :width="900">
    <a-form-model
      ref="editInstanceForm"
      :model="instance"
      :rules="rules"
      layout="vertical"
    >
      <h5>Company Details:</h5>
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-model-item label="Business" prop="business.id">
            <a-select
              v-model="instance.business.id"
              style="width: 100%"
              :disabled="currentMode == modes.edit"
            >
              <a-select-option
                v-for="business in businesses"
                :key="business.id"
                :value="business.id"
              >
                {{ business.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Company name" prop="name">
            <a-input placeholder="Company name" v-model="instance.name" />
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item label="Instance URL" prop="url">
            <a-input
              placeholder="http://www.test.mygls.co.uk"
              v-model="instance.url"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <div>
        <a-row :gutter="16">
          <a-col :span="5">
            <a-form-model-item label="Email" prop="email">
              <a-input placeholder="Email" v-model="instance.email" />
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="Firm Type" prop="firmType.id">
              <a-select v-model="instance.firmType.id" style="width: 100%">
                <a-select-option
                  v-for="firmType in firmTypes"
                  :key="firmType.id"
                  :value="firmType.id"
                >
                  {{ firmType.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="4">
            <a-form-model-item label="Firm Size" prop="firmSize.id">
              <a-select v-model="instance.firmSize.id" style="width: 100%">
                <a-select-option
                  v-for="firmSize in firmSizes"
                  :key="firmSize.id"
                  :value="firmSize.id"
                >
                  {{ firmSize.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="Channel" prop="channelId">
              <a-select v-model="instance.channelId" style="width: 100%">
             
                <a-select-option
                  v-for="channel in channels"
                  :key="channel.id"
                  :value="channel.id"
                >
                  {{ channel.name }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
            <a-col :span="5">
            <a-form-model-item label="Account Handler" prop="accountHandlerId">
              <a-select v-model="instance.accountHandlerId" style="width: 100%">
               <a-select-option key="empty" :value="null" >Not Assign</a-select-option>
                <a-select-option
                  v-for="handler in accountHandlers"
                  :key="handler.id"
                  :value="handler.id"
                >
                  {{`${handler.firstname} ${handler.lastname} (${handler.initial}) | ${handler.country.name}` }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="5">
            <a-form-model-item label="Sales Handler" prop="salesId">
              <a-select v-model="instance.salesId" style="width: 100%">
                <a-select-option
                  v-for="handler in salesHandlers"
                  :key="handler.salesId"
                  :value="handler.salesId"
                >
                  {{`${handler.name} ${handler.surname} (${handler.initial})` }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
      <a-divider style="margin-top: 2px" />
      <h5>Subscription Details:</h5>
      <a-row :gutter="16">
        <a-col :span="8">
          <a-form-model-item
            label="Plan"
            prop="companySubscription.subscriptionPlanId"
          >
            <a-select
              v-model="instance.companySubscription.subscriptionPlanId"
              style="width: 100%"
            >
              <a-select-option
                v-for="plan in plans"
                :key="plan.id"
                :value="plan.id"
              >
                {{ plan.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            label="Start Date"
            prop="companySubscription.startDate"
          >
            <DateTimePickr
              :date="instance.companySubscription.startDate"
              @onChange="onStartDateChange"
            ></DateTimePickr>
          </a-form-model-item>
        </a-col>
        <a-col :span="8">
          <a-form-model-item
            label="No. of subscribers"
            prop="companySubscription.subscriptionQuantity"
          >
            <a-input-number
              class="width-100"
              v-model="instance.companySubscription.subscriptionQuantity"
              :min="1"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-divider style="margin-top: 2px" />
      <div >
      <h6>Addons:</h6>
      <a-row :gutter="16" v-if="this.instance.companyAddons && this.instance.companyAddons.length > 0">
        <a-col>
          <a-checkbox v-for="(item,index) in this.instance.companyAddons" :key="index" v-model="item.isSubscribed">
          {{item.addon.name}}
          </a-checkbox>
        </a-col>
      </a-row>
      <a-row v-else>
        <h6><span style="color:red"> No active addons</span> </h6>
      </a-row>
      </div>
      <a-divider />
      <h5>Contact Person:</h5>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-form-model-item label="Title" prop="contactPerson.title">
            <a-select
              v-model="instance.contactPerson.title"
              :default-value="
                instance.contactPerson ? instance.contactPerson.title : ''
              "
              placeholder="Title"
              style="width: 100%"
            >
              <a-select-option
                v-for="title in titles"
                :key="title"
                :value="title"
              >
                {{ title }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="First name" prop="contactPerson.firstName">
            <a-input
              placeholder="First Name"
              v-model="instance.contactPerson.firstName"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="Surname" prop="contactPerson.lastName">
            <a-input
              placeholder="Surname"
              v-model="instance.contactPerson.lastName"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="Phone" prop="contactPerson.phone">
            <a-input
              v-model="instance.contactPerson.phone"
              placeholder="Phone number"
            >
              <a-icon slot="prefix" type="phone" />
            </a-input>
          </a-form-model-item>
        </a-col>
      </a-row>
      <h6>Address:</h6>
      <a-row :gutter="16">
        <a-col :span="6">
          <a-form-model-item label="Line 1">
            <a-input placeholder="Line 1" v-model="instance.address.line1" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="Line 2">
            <a-input placeholder="Line 2" v-model="instance.address.line2" />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="Post code">
            <a-input
              placeholder="Post code"
              v-model="instance.address.postCode"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="6">
          <a-form-model-item label="Country" prop="country">
            <a-select v-model="instance.address.countryId" style="width: 100%">
              <a-select-option
                v-for="country in countries"
                :key="country.id"
                :value="country.id"
              >
                {{ country.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-divider style="margin-top: 2px" />
      <div v-if="instance.instanceManagerId != null && instance.subscriptionStatus != 3">
        <h5>Instances Configurations:</h5>
        <a-row :gutter="16">
          <a-col :span="8">
            <a-form-model-item label="Auto Update Instance">
              <a-switch v-model="instance.autoUpdate" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </div>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">{{
        actionButtonText
      }}</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { helper } from "../../Utilities/helper";
import { regex } from "../../Utilities/constants";
import moment from "moment";

const EVENTS = { triggerUpdate: "triggerUpdate", triggerAdd: "triggerAdd" };

export default {
  props: {
    value: Boolean,
    businesses: Array,
    instance: { type: Object, default: () => {} },
    plans: Array,
    titles: Array,
    isSaving: Boolean,
    modes: Object,
    currentMode: String,
    firmTypes: Array,
    firmSizes: Array,
    countries: Array,
    channels: Array,
    accountHandlers: Array,
    salesHandlers: Array,
  },
  data() {
    return {
      rules: {
        name: [
          {
            required: true,
            message: "Please input comapny name",
            trigger: "blur",
          },
        ],
        url: [
          { required: true, message: "Please input URL", trigger: "blur" },
          { validator: helper.urlValidator, trigger: "blur" },
        ],
        email: [
          { required: true, message: "Please input an email", trigger: "blur" },
          {
            pattern: regex.email,
            message: "Please enter a valid email",
            trigger: "blur",
          },
        ],
        "firmType.id": [
          {
            required: true,
            message: "Please select a firm type",
            trigger: "blur",
          },
        ],
        "firmSize.id": [
          {
            required: true,
            message: "Please select a firm size",
            trigger: "blur",
          },
        ],
        "contactPerson.name": [
          {
            required: true,
            message: "Please input an contact name",
            trigger: "blur",
          },
          { validator: helper.nameValidator, trigger: "blur" },
        ],
        "contactPerson.phone": [
          {
            required: true,
            message: "Please input your phone number",
            trigger: "blur",
          },
          { validator: helper.phoneValidator, trigger: "blur" },
        ],
        "companySubscription.subscriptionPlanId": [
          {
            required: true,
            message: "Please select a subscription plan",
            trigger: "change",
          },
        ],
        "business.id": [
          {
            required: true,
            message: "Please pick a Business",
            trigger: "change",
          },
        ],
        "companySubscription.startDate": [
          {
            required: true,
            message: "Please select a start date",
            trigger: "blur",
          },
          { validator: helper.dateFormatValidator, trigger: "blur" },
        ],
        "companySubscription.subscriptionQuantity": [
          {
            required: true,
            message: "Please select a subsctiption quantity",
            trigger: "blur",
          },
        ],
        "channelId": [
          {
            required: true,
            message: "Please select a channel",
            trigger: "blur",
          },
        ],
      },
      isDateChanged: false
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    title() {
      return this.currentMode == this.modes.add
        ? "Add a new comapny"
        : "Edit comapny details";
    },
    actionButtonText() {
      return this.currentMode == this.modes.add ? "Add" : "Update";
    },
    startDate() {
      return this.instance.companySubscription.startDate;
    },
    disabledEditing() {
      return (
        !this.isDateChanged &&
        this.currentMode == this.modes.edit &&
        moment().diff(
          moment(this.instance.companySubscription?.startDate, "DD/MM/YYYY"),
          "minute"
        ) > 0
      );
    },
  },
  methods: {
    onStartDateChange(dateVal) {
      this.isDateChanged = true;
      this.instance.companySubscription.startDate = dateVal;
    },
    cancel() {
      this.visible = false;
    },
    save() {
      this.$refs.editInstanceForm.validate(async (valid) => {
        if (valid) {
          const tokenKey = this.businesses.find(
            (b) => b.id === this.instance.business.id
          )?.tokenKey;

          let event =
            this.currentMode == this.modes.add
              ? EVENTS.triggerAdd
              : EVENTS.triggerUpdate;
          this.$emit(event, {
            id: this.instance.id,
            name: this.instance.name,
            isActive: this.instance.isActive,
            url: this.instance.url,
            email: this.instance.email,
            tokenKey: tokenKey,
            token: this.instance.token,
            businessId: this.instance.business.id,
            contactTitle: this.instance.contactPerson.title,
            contactFirstName: this.instance.contactPerson.firstName,
            contactLastName: this.instance.contactPerson.lastName,
            contactPhone: this.instance.contactPerson.phone,
            subscriptionPlanId:
              this.instance.companySubscription.subscriptionPlanId,
            subscriptionQuantity:
              this.instance.companySubscription.subscriptionQuantity,
            startDate: this.instance.companySubscription.startDate,
            address: this.instance.address,
            firmTypeId: this.instance.firmType.id,
            firmSizeId: this.instance.firmSize.id,
            channelId: this.instance.channelId,
            autoUpdate: this.instance.autoUpdate,
            CompanyAddons: this.instance.companyAddons,
            accountHandlerId:this.instance.accountHandlerId,
            salesId: this.instance.salesId,
          });
        }
      });
    },
  },
  watch: {
    startDate() {
      this.$refs.editInstanceForm?.validateField(
        "companySubscription.startDate"
      );
    },
    instanceProp() {
      this.instance = { ...this.instanceProp };
    }
  },
  components: {},
};
</script>

<style lang="scss" scoped>
</style>
